export { default } from "./index.web";
